// hooks/useLanguageData.js - Amélioré avec gestion du chargement initial
import { useState, useEffect, useCallback } from 'react';
import { useApiProxy } from './useApiProxy';
import { useLanguage } from '../hooks/LanguageContext';

export const useLanguageData = (baseUrl, options = {}) => {
  const { currentLanguage } = useLanguage();
  const { loading, error, fetchApi } = useApiProxy();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const fetchData = useCallback(async () => {
    if (!baseUrl) return;
    
    setIsLoading(true);
    try {
      // Construire l'URL avec le paramètre locale si nécessaire
      let url = baseUrl;
      if (currentLanguage === 'en') {
        const separator = url.includes('?') ? '&' : '?';
        url = `${url}${separator}locale=en`;
      }
      
      console.log(`🌐 Chargement données (${currentLanguage}): ${url}`);
      const result = await fetchApi(url);
      setData(result);
      setHasLoaded(true);
    } catch (err) {
      console.error(`Erreur chargement données (${currentLanguage}):`, err);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl, currentLanguage, fetchApi]);

  useEffect(() => {
    fetchData();
  }, [fetchData, currentLanguage]); // Ajouter currentLanguage comme dépendance explicite

  return { 
    data, 
    loading: isLoading || loading, 
    error, 
    refetch: fetchData,
    hasLoaded 
  };
};